import { createSlice } from "@reduxjs/toolkit";
import { updateDoctorDocument } from "../../reducer/updateUploadedDoctorDocuments/updateDoctorDocumentReducer";

import i18n from "../../i18n";
const initialState = {
  data: {},
  isLoading: false,
  success: false,
  error: null,
};

const updateDoctorDocumentsSlice = createSlice({
  name: "updateDoctorDocuments",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(updateDoctorDocument.pending, (state) => {
        state.isLoading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(updateDoctorDocument.fulfilled, (state, action) => {
        state.isLoading = false;
        state.success = true;
        state.data = action.payload;
      })
      .addCase(updateDoctorDocument.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || i18n.t("toast.failedToUpdateDoctorDocuments");
      });
  },
});

export default updateDoctorDocumentsSlice.reducer;
